module.exports = __webpack_public_path__ + "img/ABREVIATURAS.eced227f.png";